/**
 * PhotoAttribution - Unsplash photo credit overlay
 *
 * Displays photographer credit per Unsplash license guidelines.
 * Issue #765
 */

interface PhotoAttributionProps {
  photographer: string;
  unsplashUsername?: string;
  position?: 'bottom-left' | 'bottom-right';
}

export default function PhotoAttribution({
  photographer,
  unsplashUsername,
  position = 'bottom-right'
}: PhotoAttributionProps) {
  const positionClasses = position === 'bottom-left'
    ? 'left-2 bottom-2'
    : 'right-2 bottom-2';

  const content = (
    <span className="text-[11px] text-white/80 bg-black/40 px-2 py-0.5 rounded backdrop-blur-sm">
      Photo by {photographer}
    </span>
  );

  if (unsplashUsername) {
    return (
      <a
        href={`https://unsplash.com/@${unsplashUsername}?utm_source=oro&utm_medium=referral`}
        target="_blank"
        rel="noopener noreferrer"
        className={`absolute ${positionClasses} hover:opacity-100 opacity-70 transition-opacity`}
        aria-label={`View ${photographer}'s profile on Unsplash`}
      >
        {content}
      </a>
    );
  }

  return (
    <span className={`absolute ${positionClasses} opacity-70`}>
      {content}
    </span>
  );
}
